import { CubeTimeDimensionGranularity } from "../../../enum/cube-schema.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryTeamTotalMetricsRequestParamsDto {
    startDate: string;
    endDate: string;
    teamId: string;
    userIds?: string[];
    appIds: string[];
    frequency: CubeTimeDimensionGranularity;
}